import NewButton from "../Buttons/newButton";
import Modal from "./Modal";

interface warningProps {
  showModal: boolean;
  setShowModal: React.Dispatch<React.SetStateAction<boolean>>;
  title: string;
  message: string;
}

const WarningModal: React.FC<warningProps> = ({
  showModal,
  setShowModal,
  title,
  message,
}) => {
  const dismiss = () => setShowModal(false);

  return (
    <Modal
      isModalOpen={showModal}
      toggleModal={dismiss}
      title={title}
      compact
      compactBodyScrolls={false}
      className="max-w-md w-full"
    >
      <p className="text-gray-font text-base font-normal leading-6">{message}</p>
      <div className="mt-6 flex justify-end border-t border-neutral-200 pt-4">
        <NewButton
          text="OK"
          style="filled"
          size="medium"
          color="accent"
          content="text"
          onClick={dismiss}
          className="!w-auto shrink-0 min-w-[7rem]"
        />
      </div>
    </Modal>
  );
};

export default WarningModal;
